// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as Logo$BenfaerberBlog from "./Logo.bs.js";
import * as AppContext$BenfaerberBlog from "../AppContext.bs.js";
import * as ReactRouterDom$BenfaerberBlog from "../wrappers/ReactRouterDom.bs.js";

function s(prim) {
  return prim;
}

function Title(props) {
  var match = React.useState(function () {
        return 0;
      });
  var setCounter = match[1];
  var match$1 = React.useContext(AppContext$BenfaerberBlog.context);
  var logo = match$1.logo;
  var onLogoClick = function (param) {
    setCounter(function (s) {
          if (s > 5) {
            return 0;
          } else {
            return s + 1 | 0;
          }
        });
  };
  return JsxRuntime.jsxs("div", {
              children: [
                match[0] < 5 ? JsxRuntime.jsx("div", {
                        children: Logo$BenfaerberBlog.asEmoji(logo),
                        className: "ferris",
                        onClick: onLogoClick
                      }) : JsxRuntime.jsx(ReactRouterDom$BenfaerberBlog.Link.make, {
                        children: JsxRuntime.jsx("div", {
                              children: Logo$BenfaerberBlog.asEmoji(logo),
                              className: "ferris",
                              onClick: onLogoClick
                            }),
                        href: "/projects/secret"
                      }),
                JsxRuntime.jsx("span", {
                      className: "px-2"
                    }),
                JsxRuntime.jsx(ReactRouterDom$BenfaerberBlog.Link.make, {
                      children: "What the Functor?",
                      href: "/",
                      className: "black-link"
                    })
              ],
              className: "is-flex flex-center monospace h100"
            });
}

var make = Title;

export {
  s ,
  make ,
}
/* react Not a pure module */
